export default "__VITE_ASSET__C8qOx7jG__"